import { AnyAction } from '@reduxjs/toolkit';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { setLoading } from '../common/CommonSlice';
import { AssetActions } from './AssetActions';
import api from '../../apiServices';

function* getObjectSaga(action: AnyAction): any {
  try {
    yield put(setLoading(true));
    const { key } = action.payload;
    const asset = yield call(api.asset.getObject, key);
  } catch (error) {
    console.log(error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* assetSaga() {
  yield all([takeLatest(AssetActions.getObject, getObjectSaga)]);
}
